module.exports = __webpack_public_path__ + "img/dwzzzz.4087dd3f.png";